import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { PropTypes } from 'prop-types';
import ReactTable from 'react-table';

import ApplicationStatus from './ApplicationStatus'

const ApplicationView = ({ application, emails, emailPageSize, onEmailClick }) => {

  let formattedLastModified;
  try {
    formattedLastModified = new Date(application.updated_time).toISOString();
  } catch(error) { 
    formattedLastModified = 'invalid date';
  }
  
  let getEmailTableTrProps = (state, rowInfo) => ({
    onClick: () => {
      if (onEmailClick !== undefined) {
        onEmailClick(rowInfo.original)
      }
    }
  });

  return (
    <div>
      <Row className="details border mx-0 pt-3">
        <Col>
          <dl className="row">
            <dt className="col">Application:</dt>
            <dd className="col">{application.request_name}</dd>
            <dt className="col">Status:</dt>
            <dd className="col">
              <ApplicationStatus application={application} />
            </dd>
          </dl>
          <dl className="row">
            <dt className="col">Last updated by:</dt>
            <dd className="col">{application.last_updated_by}</dd>
            <dt className="col">Last modified:</dt>
            <dd className="col">{formattedLastModified}</dd>
          </dl>
        </Col>
      </Row>
      <h3>Ofcom Email History</h3>
      <Row>
        <Col>
          <ReactTable
            className="-striped -highlight"
            columns={[
              {
                accessor: 'subject',
              },
              {
                id: 'date',
                accessor: email => {
                  try {
                    return new Date(email.date).toISOString()
                  } catch (error) { 
                    return 'invalid date'
                  }
                }
              },
              {
                accessor: 'from_email',
              },
              {
                accessor: 'body',
              },
            ]}
            data={emails}
            defaultPageSize={emailPageSize}
            defaultSorted={[
              {
                id: 'date',
                desc: true,
              },
            ]}
            getTheadProps={() => ({
              class: 'd-none',
            })}
            getTrProps={getEmailTableTrProps}
          />
        </Col>
      </Row>
    </div>
  );
}

ApplicationView.propTypes = {
  /**
   * The application to view.
   */
  application: PropTypes.object.isRequired,
  /**
   * Optional a list of the emails fpr this application.
   */
  emails: PropTypes.array,
  /**
   * Optional page size for the email table.
   */
  emailPageSize: PropTypes.number,
  /**
   * Optional called when an email is clicked, passed the original email object the row contains.
   */
  onEmailClick: PropTypes.func,
};

ApplicationView.defaultProps = {
  emails: [],
  emailPageSize: 10,
};

export default ApplicationView;